<template>
  <div>
    <v-data-table
      :headers="activeHeaders"
      :items="datasetReducer"
      :server-items-length="total"
      :options.sync="options"
      :hide-default-footer="!(_currentClient.client_name === 'shark')"
      :loading="_loadingStates.screensLoaded"
      class="elevation-1"
      :footer-props="{
        'items-per-page-options': [50, 100, 150],
      }"
      @update:options="_getAllScreensData(options)"
      @click:row="goTo"
    >
      <template v-slot:top>
        <search v-if="showMobileView" :searchTypes="setSearchTypes" />

        <filter-bar
          v-if="!showMobileView"
          name="screens"
          :searchTypes="setSearchTypes"
          :filter="_getScreensFilter"
        />
        <div
          class="d-flex flex-column"
          :style="showMobileView ? '' : 'width:100%;'"
        >
          <div class="d-flex justify-end pt-2">
            <v-btn
              class="mt-4 mr-4 d-flex align-center"
              color="black"
              v-if="showMobileView"
              @click="_setFilter(true)"
            >
              <v-icon color="white">mdi-filter</v-icon>
            </v-btn>
            <v-btn
              :class="addScreenPlacement"
              v-if="isAdmin && _currentClient.client_name !== 'shark'"
              color="black"
              @click="_setNewScreen(true)"
            >
              <v-row>
                <v-spacer />
                <v-col>
                  <v-icon color="white">mdi-plus</v-icon>
                </v-col>
                <v-spacer />
              </v-row>
            </v-btn>
          </div>
        </div>
        <add-screen v-if="!_loadingStates.screensLoaded" />
      </template>
      <template
        v-if="_currentClient.client_name === 'shark'"
        v-slot:item.network_status="{ item }"
      >
        <v-icon :color="item.network_status" x-large> mdi-circle-medium</v-icon>
      </template>

      <template v-slot:item.gpsi_car_number="{ item }">
        <v-icon
          :color="item.status"
          x-large
          v-if="item.device_id && _currentClient.client_name !== 'shark'"
        >
          mdi-circle-medium</v-icon
        >
        <span v-if="item.device_id && _currentClient.client_name === 'shark'">
          {{ item.gpsi_car_number }}
        </span>
        <span v-if="item.device_id && _currentClient.client_name !== 'shark'">
          {{ item.device_id }}
        </span>
      </template>
      <template v-slot:item.launch_mode="{ item }">
        {{ formatLaunch(item.launch_mode) }}
      </template>
      <template v-slot:item.last_activity="{ item }">
        {{ formatDate(item.last_activity) }}
      </template>

      <template v-slot:item.group_name="{ item }">
        <div class="text-capitalize">
          {{ item.group_name }}
        </div>
      </template>
    </v-data-table>

    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      v-if="!_loadingStates.screens"
    >
      {{ _createMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import AddScreen from './AddScreen.vue';
import FormatDate from '@/mixins/FormatDate';
import Search from '@/components/app/Search';
import FilterBar from '@/components/app/FilterBar';
import { MobileView, UserPermissions } from '@/mixins';
import Options from '@/mixins/Options';
import { matchSearchString } from '@/utils/stringHelpers';

export default {
  name: 'AllScreens',
  mixins: [MobileView, UserPermissions, Options, FormatDate],
  components: {
    Search,
    AddScreen,
    FilterBar,
  },

  data: () => ({
    snackbar: false,
    snackbarText: false,
    timeout: 2000,
    screenHeaders: [
      { text: 'Screen', value: 'gpsi_car_number' },
      // { text: "Group Name", value: "group_name" },
      { text: 'Rental Status', value: 'status' },
      { text: 'Trip Type', value: 'trip_type' },
      { text: 'Version', value: 'version' },
      { text: 'Latest Activity', value: 'last_activity' },
    ],
    sharkHeaders: [
      { text: '', value: 'network_status' },
      { text: 'Golf Car', value: 'car_number' },
      { text: 'Course Name', value: 'group_name' },
      { text: 'Launch Mode', value: 'launch_mode' },
      { text: 'GPSi Car ID', value: 'gpsi_car_id' },
      // { text: "GPSi Car #", value: "gpsi_car_number" },
      { text: 'Version', value: 'version' },
      { text: 'MDN', value: 'mdn' },
      { text: 'Latest Activity', value: 'last_activity' },
    ],

    searchTypes: ['Group Name', 'Device ID', 'Phone Number'],
    sharkSearchTypes: [],
  }),
  computed: {
    ...mapGetters({
      _dataset: 'screens/getAllScreens',
      _getQueryParams: 'screens/getQueryParams',
      _getScreensFilter: 'filters/getFilter',
      _createMessage: 'screens/getScreenCreate',
      _currentClient: 'account/getCurrentClient',
      _loadingStates: 'screens/getLoadingStates',
    }),
    total() {
      if (this._currentClient.client_name === 'shark') {
        return this._dataset[0] ? parseInt(this._dataset[0].total) : 0;
      }
      return this._dataset.length;
    },
    datasetReducer() {
      if (
        this._getScreensFilter.search &&
        (this._getScreensFilter.searchType === 'Course Name' ||
          this._getScreensFilter.searchType === 'Group Name')
      ) {
        const groupIds = this._currentClient.groups.reduce((a, c) => {
          if (matchSearchString(c.group_name, this._getScreensFilter.search)) {
            a.push(c.uuid);
          }
          return a;
        }, []);
        const courses = this._dataset.reduce((a, c) => {
          if (groupIds.includes(c.group_id)) {
            a.push(c);
          }
          return a;
        }, []);
        return courses;
      }
      return this._dataset;
    },
    queryParams: {
      get() {
        return this._getQueryParams;
      },
      set(val) {
        this._setQueryParams(val);
      },
    },
    addScreenPlacement() {
      if (this.showMobileView) {
        return 'mr-4 mt-4 d-flex align-center justify-end';
      }
      return 'mr-4 mt-0 d-flex align-center';
    },
    activeHeaders() {
      if (this._currentClient.client_name !== 'shark') {
        return this.screenHeaders;
      }
      return this.sharkHeaders;
    },
    setSearchTypes() {
      if (this._currentClient.client_name !== 'shark') {
        return this.searchTypes;
      }
      return this.sharkSearchTypes;
    },
  },
  methods: {
    ...mapMutations({
      _setFilter: 'filters/setFilters',
      _setNewScreen: 'screens/setNewScreen',
      _setActiveStatus: 'screens/setActiveStatus',
      _setQueryParams: 'screens/setQueryParams',
      setScreensFilter: 'filters/setScreensFilter',
      setCreateScreen: 'screens/setScreenCreate',
    }),
    ...mapActions({
      _getAllScreensData: 'screens/getAllScreensData',
    }),
    goTo(item) {
      this.$router.push({ path: `${this.$route.fullPath}/${item.uuid}` });
      window.location.reload();
    },
    getGroup(id) {
      let screenGroup = {};
      this._currentClient.groups.map(group => {
        if (group.uuid === id) {
          screenGroup = group;
        }
      });
      if (screenGroup.group_name) {
        return screenGroup.group_name
          .toLowerCase()
          .split(' ')
          .map(s => s.charAt(0).toUpperCase() + s.substring(1))
          .join(' ');
      }
      return screenGroup.group_name;
    },
    capitalize(text) {
      if (text) {
        return text
          .toLowerCase()
          .split(' ')
          .map(s => s.charAt(0).toUpperCase() + s.substring(1))
          .join(' ');
      }
    },
    formatLaunch(type) {
      switch (type) {
        case 'b2b':
        case 'interface_select_bt':
          return 'Bluetooth';
        case 'interface_select':
          return 'Select';
        case 'interface_select_plus':
          return 'Select+';
        case 'interface_select_plus_plus':
          return 'Select++';
        case 'interface_prime':
          return 'Prime';
        default:
          break;
      }
    },
  },
  watch: {
    _createMessage() {
      if (this._createMessage) {
        this.snackbar = true;
      }
    },
    snackbar() {
      if (!this.snackbar) {
        this.setCreateScreen(null);
      }
    },
  },
};
</script>

<style scoped>
.capitalize {
  text-transform: capitalize;
}
</style>
